module.exports = __webpack_public_path__ + "img/traditional-nepali-khana.jpg";